import React from 'react';
import { 
  Routes,
  Route, 
} from "react-router-dom";

import VideoCall from './components/VideoCall';
//import VideoCall_v2 from './components/VideoCall_v2';
import NotFound from './components/NotFound';
//import CheckPage from './components/CheckPage';


function App() {

  return (
   <>
    <Routes>
      <Route path="/guid/:call_guid" element={<VideoCall/>} />
      {
        //<Route path="/testui/:call_guid" element={<VideoCall_v2/>} />
        //<Route path="/check_page" element={<CheckPage/>} />    
      }
       
      <Route path="*" element={<NotFound/>} />
    </Routes>
   </>
   
  );
}

export default App;

